export default __webpack_public_path__ + "static/media/pos.49092c2c.png";